module.exports = __webpack_public_path__ + "media/images/swiss/logos/a_star_alliance2-14423fb8219976174c7337c1eb239bd2.png";